import session from '../util/session'
import { addQueryParams } from 'shared/javascripts/util/query'
import { registrationEntryPath } from 'shared/javascripts/util/registration'
import { trackElementInteraction } from '../util/analytics'

up.compiler('[data-custom-playlist-link]', (element: HTMLElement) => {
  const url = element.getAttribute('data-custom-playlist-link')!

  element.addEventListener('click', (event: MouseEvent) => {
    // tracking: video_page.learning_plan_modal_open
    // Reported here rather than with `data-track-click`, because the handler stops the click from
    // propagating and Unpoly's `up:click` — which that attribute listens for — never fires.
    trackElementInteraction(element, 'click.element')

    if (session.signedIn) {
      const fullUrl = addQueryParams(url)
      void up.layer.open({
        url: fullUrl,
        target: ':main',
        history: false,
        onDismissed: () => up.focus(element),
      })
    } else {
      const returnTo = window.location.pathname + window.location.search
      up.visit(registrationEntryPath(returnTo))
    }

    event.preventDefault()
    event.stopPropagation()
  })
})
